module.exports = __webpack_public_path__ + "img/teater.e56f8a44.jpg";